import { NavLink } from 'react-router';

/** Bereiche des Moduls: die laufenden Verträge, geplante Vorhaben (Tragfähigkeit und Mappe für die Bank) und die Kostenstruktur, aus der sich beides speist */
export function FinancingTabs() {
  return (
    <nav className="subnav" aria-label="Bereiche von Finanzierungen und Leasings">
      <NavLink to="/finanzierungen" end>Verträge</NavLink>
      <NavLink to="/finanzierungen/vorhaben">Vorhaben</NavLink>
      <NavLink to="/finanzierungen/kosten">Kostenstruktur</NavLink>
    </nav>
  );
}
